import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/useinfo/icon-slide-arrow.png'
import _imports_1 from '@/assets/icon-close.png'


const _withScopeId = n => (_pushScopeId("data-v-54a040c9"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dark--layer" }, null, -1))
const _hoisted_2 = { class: "slide--wrapper" }
const _hoisted_3 = { class: "slide-arrow" }
const _hoisted_4 = { class: "slide-section" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "slider-area" }, null, -1))
const _hoisted_6 = { class: "slider-container" }
const _hoisted_7 = { class: "slider-wrapper" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "indicator--wrapper" }
const _hoisted_11 = { class: "slide-arrow" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("img", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.executeArrow('minus'))),
          class: "__reverse",
          src: _imports_0,
          alt: "왼쪽 회살표"
        }, null, 512), [
          [_vShow, _ctx.page !== 0]
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("img", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeSlider && _ctx.closeSlider(...args))),
          class: "image-close",
          src: _imports_1,
          alt: "닫기 아이콘"
        }),
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slideItems, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "slide-item",
                key: item.image
              }, [
                _createElementVNode("div", {
                  class: "title",
                  innerHTML: item.title
                }, null, 8, _hoisted_8),
                _createElementVNode("div", {
                  class: "contents",
                  innerHTML: item.contents
                }, null, 8, _hoisted_9)
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slideItems, (item, idx) => {
            return (_openBlock(), _createElementBlock("span", {
              class: _normalizeClass([{ __active: _ctx.page === idx }, "indicator"]),
              key: idx
            }, null, 2))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _withDirectives(_createElementVNode("img", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.executeArrow('plus'))),
          src: _imports_0,
          alt: "오른쪽 회살표"
        }, null, 512), [
          [_vShow, _ctx.page !== _ctx.slideItems.length - 1]
        ])
      ])
    ])
  ], 64))
}